import { Button, Flex, Grid } from '@sequencehq/core-components'
import {
  GreyGrey30,
  GreyGrey70,
  GreyWhite,
  Primary13Regular,
  Spinner
} from '@sequencehq/core-components'
import { useAtomValue } from 'jotai'
import { useState } from 'react'
import { LLMFeedback } from './LLMFeedback'
import { automationExecutionAtom, isFinalStepAtom } from '../../../atoms'

export const StepFooter = (props: {
  onNext?: () => Promise<void>
  onBack?: () => void
  nextDisabled?: boolean
  backDisabled?: boolean
  finalStepButtonText?: string
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isFinalStep = useAtomValue(isFinalStepAtom)
  const automationExecutionId = useAtomValue(automationExecutionAtom)
  const finalStepButtonText = props.finalStepButtonText ?? 'Finish review'

  return (
    <Grid
      gridTemplateColumns="1fr auto"
      width="100%"
      padding="12px"
      borderTop={`1px solid ${GreyGrey30}`}
      alignItems="center"
    >
      <Flex
        {...Primary13Regular}
        color={GreyGrey70}
        paddingLeft="8px"
        gap="4px"
      >
        AI extractions may include mistakes.
        {automationExecutionId && (
          <LLMFeedback automationExecutionId={automationExecutionId} />
        )}
      </Flex>
      <Flex gap="8px">
        <Button
          data-testid="watchtower.stepFooter.back"
          variant="secondary"
          disabled={props.backDisabled}
          onClick={() => {
            props.onBack?.()
          }}
        >
          Back
        </Button>
        <Button
          data-testid="watchtower.stepFooter.next"
          disabled={props.nextDisabled || isSubmitting}
          onClick={async () => {
            setIsSubmitting(true)
            await props.onNext?.()
            setIsSubmitting(false)
          }}
          trailingIcon={
            isSubmitting ? <Spinner size="sm" color={GreyWhite} /> : undefined
          }
        >
          {isFinalStep ? finalStepButtonText : 'Continue'}
        </Button>
      </Flex>
    </Grid>
  )
}
